import React from 'react';
import { FormattedDate } from 'react-intl';
import { useLocalizationContext } from '../LocalizationProvider';
import toDateTime from '../util/toDateTime';

export const ShortDate = ({ date, withDayOfWeek = false }) => {
  const { timeZone } = useLocalizationContext();

  const dateTime = React.useMemo(() => toDateTime(date, timeZone), [date, timeZone]);

  if (!date) return null;

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone,
  };

  return <FormattedDate value={dateTime} {...options} weekday={withDayOfWeek ? 'short' : undefined} />;
};
